const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    maxWidth: minWidth / 1.5,
    width: 500,
    height: 600
  },
  modalHeader: {
    fontWeight: '600!important',
    fontSize: '1.2rem!important',
  },
  form: {
    maxHeight: minHeight / 2
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding: 0,
    minWidth: 40,
  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
  },
  deviceType: {
    width: '350px'
  }
})

export default styles
